import LegalDocument from "@/components/LegalDocument";
import LegalComingSoon from "@/components/LegalComingSoon";
import { TERMS } from "@/lib/legal/termsContent";
import { LEGAL_FACTS_READY } from "@/lib/legalConfig";

export default function Terms() {
  if (!LEGAL_FACTS_READY) return <LegalComingSoon title="Terms of Use" path="/terms" testId="terms-coming-soon" />;
  return (
    <LegalDocument
      doc={TERMS}
      path="/terms"
      description="The terms for using RateCurrent's ESID lookup and bill-check tools: what we are and are not, accuracy, acceptable use, uploads, and liability."
      testId="terms-page"
    />
  );
}
